/* ROCKJAW x Sports Science page. Progressive enhancement only: every chapter is readable,
   every toggle works (radios + CSS) and every accordion opens (native details) without this file.
   Analytics: PostHog (already consent-gated by snippets/posthog-tracking.liquid, only present after
   analytics consent) and Shopify.analytics.publish (customer-events pixels, consent-aware).
   No health data is ever sent: only event name, a fixed label and the page path. */
(function () {
  'use strict';
  var root = document.querySelector('.rj-sci-hero');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function track(name, label) {
    var props = { label: String(label || ''), page: location.pathname };
    try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, props); } catch (e) {}
  }

  /* click tracking: hero CTAs, product CTAs, external study links */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-rj-track]');
    if (a && a.closest('.rj-sci')) track(a.getAttribute('data-rj-track'), a.getAttribute('data-rj-label'));
    var s = e.target.closest && e.target.closest('.rj-sci summary');
    if (s) {
      var d = s.parentElement;
      if (d && !d.open) {
        if (d.hasAttribute('data-rj-faq')) track('science_faq_expand', 'faq_' + d.getAttribute('data-rj-faq'));
        else if (d.hasAttribute('data-rj-track-details')) track(d.getAttribute('data-rj-track-details'), d.getAttribute('data-rj-label'));
      }
    }
  });

  /* chart toggles (thickness, resistance) */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-rj-toggle]')) track('science_chart_interaction', t.getAttribute('data-rj-toggle') + '_' + t.value);
  });
  var seenBars = new WeakSet();
  document.querySelectorAll('[data-rj-bar]').forEach(function (bar) {
    bar.addEventListener('focus', function () {
      if (seenBars.has(bar)) return;
      seenBars.add(bar);
      var chart = bar.closest('[data-rj-chart]');
      track('science_chart_interaction', (chart ? chart.getAttribute('data-rj-chart') : 'chart') + '_focus');
    });
  });

  /* No scroll-triggered bar animation: data must never depend on an observer firing (jump scrolls skip it). */

  /* library filters */
  var filters = document.querySelector('[data-rj-filters]');
  if (filters) {
    var papers = [].slice.call(document.querySelectorAll('.rj-sci-paper'));
    var status = document.querySelector('[data-rj-filter-status]');
    filters.hidden = false;
    filters.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rj-filter]');
      if (!b) return;
      var f = b.getAttribute('data-rj-filter');
      filters.querySelectorAll('[data-rj-filter]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var shown = 0;
      papers.forEach(function (p) { var on = f === 'all' || p.getAttribute('data-rj-cat') === f; p.hidden = !on; if (on) shown++; });
      if (status) status.textContent = 'Showing ' + shown + ' of ' + papers.length + ' studies';
      track('science_chart_interaction', 'library_filter_' + f);
    });
    /* a footnote link to a hidden paper resets the filter first */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#rj-sci-s"]');
      if (!a) return;
      var target = document.querySelector(a.getAttribute('href'));
      if (target && target.hidden) filters.querySelector('[data-rj-filter="all"]').click();
    });
  }

  /* chapter rail (wide screens), chapters pill (small screens), scroll spy */
  var nav = document.querySelector('[data-rj-sci-nav]');
  var pill = document.querySelector('[data-rj-sci-pill]');
  var links = [].slice.call(document.querySelectorAll('[data-rj-spy]'));
  if ('IntersectionObserver' in window && nav) {
    var heroIo = new IntersectionObserver(function (entries) {
      var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      nav.classList.toggle('is-rail', past);
      if (pill) pill.classList.toggle('is-visible', past);
      if (!past && pill) pill.open = false;
      if (!past) links.forEach(function (l) { l.removeAttribute('aria-current'); });
    });
    heroIo.observe(root);
    var ids = links.map(function (l) { return l.getAttribute('data-rj-spy'); }).filter(function (v, i, a) { return a.indexOf(v) === i; });
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var id = en.target.id;
        links.forEach(function (l) { if (l.getAttribute('data-rj-spy') === id) l.setAttribute('aria-current', 'true'); else l.removeAttribute('aria-current'); });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    ids.forEach(function (id) { var el = document.getElementById(id); if (el) spy.observe(el); });
  }
  if (pill) pill.addEventListener('click', function (e) { if (e.target.closest('a')) pill.open = false; });
})();
